import { useState, useEffect, useMemo, useLayoutEffect } from 'react';
import { siderWidth } from '../../../constants/layout'

import statusText from '../../../constants/property';
import CloseButton from '../../layouts/CloseButton';
import FilterInputBuilder from '../../filterInputBuilder/userFilter';
import OpenButton from '../../layouts/OpenButton';
import ContraTbl from '../../tables/ContraTbl';
import { contentPadding } from '../../layouts/layoutHelper';

import { FilterProvider } from '../../../context/FilterContext';
import MotionLayout from '../../general/framer-motion/MotionLayout';
import OthersTbl from '../../tables/OthersTbl';

const Index = () => {

    return (
        <MotionLayout>
            <div className='coming-soon-container'>
                <h1>Coming Soon</h1>
            </div>
        </MotionLayout>
    );
};

export default Index;




  
